import React from "react";
import Footer from "../../components/footer/footer";
import Navbar from "../../components/navbar/Navbar";
import "../all css/immigrationsection.css";
const immigration_img = require("../../assets/immigration2.svg");
const immigration_img1 = require("../../assets/immigration1.svg");
const immigration_img2 = require("../../assets/immigration4.svg");
const immigration_img3 = require("../../assets/immigration3.svg");

const allImmigrationBox = [
  {
    imgImmigration: immigration_img,
    nameImmigration: "Valid Passport",
    contentImmigration:
      "This is the foremost requisite. While you would require a legitimate passport, the requirement of the validity of your passport might vary across different countries. Some countries would demand you to have the validity until the end of the course at the time of applying for the student visa. Some, on the contrary, might let you apply but appeal you to have a validity that extends past the planned stay in the country.",
  },
  {
    imgImmigration: immigration_img1,
    nameImmigration: "Letter of Acceptance",
    contentImmigration: `Credit score plays a crucial role in determining your eligibility for loans, credit cards etc. Timely payment of credit card bills & EMIs on existing loans reflects positively on your credit score and help in improving your chances of getting an education loan.`,
  },
  {
    imgImmigration: immigration_img2,
    nameImmigration: "Language Proficiency",
    contentImmigration: `Language proficiency is perhaps another requirement for applying for a student visa. Since most of the students choose English speaking countries as the study abroad destination, most of them would require you to provide proof of proficiency in English language. For this purpose, you are required to undergo exams like TOEFL, IELTS and/or PTE.`,
  },
  {
    imgImmigration: immigration_img3,
    nameImmigration: "Proof of Funds",
    contentImmigration: `You are required to prove that you are capable of not only taking care of the tuition and college expenses but also have the essential funds to afford your stay in that country for the planned period of study. While most of the countries will demand a specific amount of funds required, some have broader and more comprehensive guidelines.`,
  },
];

function ImmigrationReadMoreSection(props) {
  return (
    <>
      <Navbar />
      <section className="immigration_main_section_container">
        <div className="section_immigration_under_container">
          <div className="section_header_for_immgration_contianer">
            <p className="title_text_immigration">IMMIGRATION</p>
            <p className="subtitle_text_immigration">
              Get yout immigration process simplified by getting in touch with
              us. We at DWEC comprises a very talented team of lawyers across
              the globe for your assistance.
            </p>
          </div>
        </div>
      </section>
      <div className="main_border_container">
        <div className="center_content_immifration">
          <p className="title_text">IMMIGRATION / VISA SERVICES</p>

          <p className="highlight_text_counselling">
            Easy and hassle free visa/immigration services by DWEC
          </p>
        </div>
        <div class="container">
          <div className="margin_container">
            <p className="highlight_text_extra_text">
              Visa/Immigration process is very time taking and can sometimes
              become a hassle. But here, at DWEC we provide visa assistance in
              India. We take care of visa applications of the students. A very
              dedicated team of lawyers works for us across the globe for
              immigration and visa services.
            </p>
          </div>
          <div className="margin_container">
            <p className="highlight_text_extra_text">
              You should apply for visa once the student confirms his/her
              enrolment in the desired university/institution.
            </p>
          </div>
          <p className="highlight_text_counselling">How to apply for visa?</p>
          <p className="highlight_text_extra_text">
            This is a very popular question among students who wish to study
            abroad. But don't worry; we have got your back. So, here are the
            steps of the visa application process:
          </p>
        </div>
        <div className="margin_container">
          <ul className="highlight_text_counselling">
            <li>
              Once you have enrolled yourself in the desired university, they
              will send you a visa documentation you need
            </li>
            <li>
              Then you can apply for visa either through offline or online mode.
            </li>
            <li>
              The documents required when applying for student visa include
              passport and visa documents from your school. You may also need
              other documents such as insurance, birth certificates, certified
              grade reports, bank account statements, photos etc.
            </li>
            <li>
              Subsequently, you need to pay a visa fees required by almost all
              the countries.
            </li>
            <li>
              Visa application in most cases takes couple of weeks to process
              your application but most of the time it varies for each person.
            </li>
          </ul>
        </div>

        <div className="">
          <p className="highlight_text_counselling">
            Documents Required for Student Visa Application
          </p>
          <p className="highlight_text_extra_text">
            Every country, depending on their Immigration Laws has a specific
            list of documents that may vary from country to country. However,
            below listed are few documents that you would require to apply for
            passport:
          </p>
        </div>

        <div className="four_box_all_container">
          {allImmigrationBox.map((perImmigration) => {
            return (
              <div className="each_box_immigration_container">
                <div className="img_container_immigration">
                  <img
                    src={perImmigration.imgImmigration.default}
                    alt="passport_img"
                  />
                </div>
                <p className="title_for_each_box_text">
                  {perImmigration.nameImmigration}
                </p>

                <p className="subtitle_for_each_box_text">
                  {perImmigration.contentImmigration}
                </p>
              </div>
            );
          })}
        </div>

        <div className="">
          <p className="highlight_text_counselling">How we can help you?</p>
          <p className="highlight_text_extra_text">
            We will help you in the entire visa application process. Our team of
            lawyers will keep you updated regarding the latest information or
            documents required for visa. In order to reduce your inconvenience
            we will handle everything and additionally, we can help you courier,
            and certify your documents.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ImmigrationReadMoreSection;
